import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import CaseStudy from "@/pages/CaseStudy";
import Trends from "@/pages/Trends";
import Saved from "@/pages/Saved";
import About from "@/pages/About";
import ExploreOpportunity from "@/pages/ExploreOpportunity";
import PatternsList from "@/pages/PatternsList";
import PatternDetail from "@/pages/PatternDetail";
import PatternExplore from "@/pages/PatternExplore";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminEditor from "@/pages/admin/AdminEditor";
import AdminDiscovery from "@/pages/admin/AdminDiscovery";
import AdminQueue from "@/pages/admin/AdminQueue";
import AdminExplorations from "@/pages/admin/AdminExplorations";
import AdminSources from "@/pages/admin/AdminSources";
import AdminPatterns from "@/pages/admin/AdminPatterns";
import AdminPatternReview from "@/pages/admin/AdminPatternReview";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <div className="flex flex-col min-h-screen">
      {!isAdmin && <Header />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/case/:slug" element={<CaseStudy />} />
          <Route path="/explore/:slug" element={<ExploreOpportunity />} />
          <Route path="/patterns" element={<PatternsList />} />
          <Route path="/pattern/:slug" element={<PatternDetail />} />
          <Route path="/pattern/:slug/explore" element={<PatternExplore />} />
          <Route path="/trends" element={<Trends />} />
          <Route path="/saved" element={<Saved />} />
          <Route path="/about" element={<About />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/cases" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/patterns" element={<ProtectedRoute><AdminPatterns /></ProtectedRoute>} />
          <Route path="/admin/patterns/:id" element={<ProtectedRoute><AdminPatternReview /></ProtectedRoute>} />
          <Route path="/admin/discovery" element={<ProtectedRoute><AdminDiscovery /></ProtectedRoute>} />
          <Route path="/admin/discovery/queue" element={<ProtectedRoute><AdminQueue /></ProtectedRoute>} />
          <Route path="/admin/explorations" element={<ProtectedRoute><AdminExplorations /></ProtectedRoute>} />
          <Route path="/admin/sources" element={<ProtectedRoute><AdminSources /></ProtectedRoute>} />
          <Route path="/admin/cases/:slug" element={<ProtectedRoute><AdminEditor /></ProtectedRoute>} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <BrowserRouter>
          <Shell />
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;
